import cn from 'classnames';

import { HOLIDAY_KEY, PICTURES_CONFIG } from '@/common/config/media-config';
import { getNumericCssVar } from '@/common/lib/cssVar';
import { designScreenRatio } from '@/common/lib/size';

interface BlockAnimationConfigType {
  png: string;
  webp?: string;
  className: string;
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

const firstBlockAnimation: BlockAnimationConfigType[] = [
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_1.png,
    webp: PICTURES_CONFIG.FIRST_SCREEN_ITEM_1.webp,
    className: 'absolute w-40 h-40 bottom-0 left-0 -rotate-[15deg]',
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_2.png,
    webp: PICTURES_CONFIG.FIRST_SCREEN_ITEM_2.webp,
    className:
      'absolute left-1/2 -translate-x-1/2 top-0 w-[11.25rem] h-[11.25rem]',
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_3.png,
    webp: PICTURES_CONFIG.FIRST_SCREEN_ITEM_3.webp,
    className: 'absolute right-0 bottom-[1.125rem] w-36 h-36',
  },
];

const secondBlockAnimation: BlockAnimationConfigType[] = [
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_4.png,
    className: cn(
      'absolute w-16 h-16',
      ['new_year', 'helloween'].includes(HOLIDAY_KEY) && 'rotate-[45deg]',
    ),
    top: 43.72,
    left: 0,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_5.png,
    className: cn(
      'absolute w-32 h-32',
      ['new_year', 'helloween'].includes(HOLIDAY_KEY) && '-scale-x-100',
    ),
    top: 9.14,
    left: 98.43,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_6.png,
    className: 'absolute w-[8.5rem] h-[8.5rem] rotate-[15deg]',
    top: 0,
    right: 111.79,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_7.png,
    className: cn(
      'absolute w-[7.5rem] h-[7.5rem] -rotate-[165deg] -scale-y-[1]',
      HOLIDAY_KEY === 'new_year' && '-scale-x-100',
    ),
    bottom: 0,
    right: 6.4,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_8.png,
    className: 'absolute w-20 h-20',
    top: 11.72,
    right: 0,
  },
];

const thirdBlockAnimation: BlockAnimationConfigType[] = [
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_9.png,
    className: cn(
      'absolute w-[6.5rem] h-[6.5rem]',
      HOLIDAY_KEY === 'helloween' && '-scale-x-100',
    ),
    left: 0,
    bottom: 9,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_10.png,
    className: cn('absolute w-24 h-24 -rotate-[15deg]'),
    top: 8.93,
    left: 53.93,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_11.png,
    className: cn(
      'absolute w-24 h-24 -rotate-[15deg]',
      HOLIDAY_KEY === 'helloween' && 'w-[7rem] h-[7rem]',
    ),
    top: 0,
    left: 195,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_12.png,
    className: 'absolute w-[6.5rem] h-[6.5rem] rotate-[15deg]',
    top: 55,
    right: 88,
  },
  {
    png: PICTURES_CONFIG.FIRST_SCREEN_ITEM_13.png,
    className: cn(
      'absolute w-20 h-20 -rotate-[45deg]',
      HOLIDAY_KEY === 'helloween' && 'rotate-[45deg]',
      HOLIDAY_KEY === 'new_year' && '-scale-x-100',
    ),
    bottom: 0,
    right: 0,
  },
];

// coff - distance (percentage / 100) to block in original image design
const calcTopDistanceForAnimationBlock = (
  coff: number,
  desktopContainerWidth?: number | null,
): number => {
  // calc bg heigh by user screen width

  const width =
    desktopContainerWidth ||
    getNumericCssVar('--desktop-container-content-width');
  const originalBgHeightByScreenWidth = width / designScreenRatio;
  //calculate the distance by which the background extends beyond the height of the screen
  const margin = (originalBgHeightByScreenWidth - window.innerHeight) / 2;

  return originalBgHeightByScreenWidth * coff - margin;
};

export {
  calcTopDistanceForAnimationBlock,
  firstBlockAnimation,
  secondBlockAnimation,
  thirdBlockAnimation,
};
